import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface BrandMarkProps {
    className?: string
}

const BrandMark: FC<BrandMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 32 32' className={cn('size-8 shrink-0', className)} aria-hidden='true'>
            <rect width='32' height='32' rx='8' className='fill-sidebar-primary' />
            <rect x='7' y='16.5' width='8' height='8' rx='1.5' className='fill-sidebar' />
            <rect x='17' y='16.5' width='8' height='8' rx='1.5' className='fill-sidebar' />
            <rect x='12' y='7.5' width='8' height='8' rx='1.5' className='fill-sidebar' opacity='0.72' />
        </svg>
    )
}

export default BrandMark
